import { CommissionsModule, PageHeader } from '@korint/folio';
import { useTranslation } from 'react-i18next';

export function Commissions() {
  const { t } = useTranslation();

  return (
    <div>
      <PageHeader title={t('sidebar.intermediary.commissions')} />
      <CommissionsModule />
    </div>
  );
}
